import { useMemo } from 'react';

// material-ui
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';

// project import
import useConfig from 'hooks/useConfig';
import Search from './Search';
import Message from './Message';
import Profile from './Profile';
import Localization from './Localization';
import Notification from './Notification';
import MobileSection from './MobileSection';
import Mode from './Mode';
import { getProject } from 'utils/common';
import { t } from 'i18next';
import useMain from 'hooks/useMain';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import navigation from 'menu-items';
import { useLocation } from 'react-router';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { i18n } = useConfig();

  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization = useMemo(() => <Localization />, [i18n]);
  const mode = useMemo(() => <Mode />, []);
  const { project, upperCaseLang } = useMain();
  const location = useLocation();

  const isDetail = location.pathname.includes('detail') || location.pathname.includes('batch') || location.pathname.includes('profile');

  // adding breadcrumbs on layout and checking with isDetail
  return (
    <Stack width="100%" direction="row" justifyContent="space-between">
      {
        project?.ProjId && !isDetail ? (
          <Stack direction="column" pl="16px">
            <Typography variant="body1"> {`${t('CONTRACT_NO')}: ${project?.ContractNo}`}</Typography>
            <Typography variant="body1">{`${t('CONTRACTOR')}: ${project[`ContractorName${upperCaseLang}`]}`}</Typography>
          </Stack>
        ) : null
        //  (
        //   <Box></Box>
        // )
      }
      {/* adding thread to control display */}
      {!isDetail && <Box></Box>}
      {isDetail && <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />}

      {/* {!matchesXs && <Search />} */}
      {/* {!matchesXs && megaMenu} */}
      {/* {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />} */}

      {/* <Notification />
      <Message /> */}
      {!matchesXs && (
        <Stack direction="row" alignItems="center">
          {mode}
          {localization}
          <Profile />
        </Stack>
      )}
      {matchesXs && <MobileSection />}
    </Stack>
  );
};

export default HeaderContent;
